import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BaseWizard from 'containers/BaseWizard';
import SimpleSidebar from 'containers/BaseWizard/components/Sidebars/SimpleSidebar';
import OverviewPage from '../OverviewPage';
import TweetsPage from '../TweetsPage';

class TrendingStoriesOverviewWizard extends Component {
  render () {
    const {
      wizardStore,
      handleClose,
      isOpen,
      timezone,
      onFetchTweets,
      handleViewChange,
      isTwitterRestricted
    } = this.props;
    return (
      <BaseWizard
        sidebarComponent={
          <SimpleSidebar
            title="Trending Story"
            pageTitles={isTwitterRestricted ? ['Overview'] : ['Overview', 'Popular Tweets']}
            handleViewChange={handleViewChange}
          />
        }
        wizardStore={wizardStore}
        handleClose={handleClose}
        isOpen={isOpen}
        onClose={handleClose}
        currentViewIndex={wizardStore.currentViewIndex}
      >
        {wizardStore.story && <OverviewPage
          title="Overview"
          story={wizardStore.story}
          shortDateString={wizardStore.shortDateString}
          analytics={wizardStore.analytics}
          storyDetails={wizardStore.storyDetails}
          loadOverviewError={wizardStore.loadOverviewError}
          loadAnalyticsError={wizardStore.loadAnalyticsError}
          timezone={timezone}
          isTwitterRestricted={isTwitterRestricted}
        />
        }
        <TweetsPage
          tweets={wizardStore.tweets}
          tweetsLoading={wizardStore.tweetsLoading}
          shortDateString={wizardStore.shortDateString}
          timezone={timezone}
          onFetchTweets={onFetchTweets}
          tweetsLoadError={wizardStore.tweetsLoadError}
        />
      </BaseWizard>
    );
  }
}

TrendingStoriesOverviewWizard.propTypes = {
  wizardStore: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  timezone: PropTypes.string,
  onFetchTweets: PropTypes.func.isRequired,
  handleViewChange: PropTypes.func.isRequired,
  isTwitterRestricted: PropTypes.bool.isRequired,
};

TrendingStoriesOverviewWizard.defaultProps = {
  timezone: 'EST',
};

export default TrendingStoriesOverviewWizard;
